const socials = [
  { name: 'GitHub', url: 'https://github.com/vivekvjyn', icon: '/logos/github.svg' },
  { name: 'LinkedIn', url: 'https://linkedin.com/in/vivekvjyn', icon: '/logos/linkedin.svg' },
  { name: 'ORCID', url: 'https://orcid.org/0009-0002-9153-7868', icon: '/logos/orcid.svg' },
];

export default socials;
